// extracted by mini-css-extract-plugin
module.exports = {"container":"about-module--container--7ZkV8","avatar":"about-module--avatar--2kpcb","avatar_text":"about-module--avatar_text--37VBN"};